import { 
  Autocomplete, 
  Box, 
  Grid, 
  TextField, 
  Divider, 
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Chip,
  Collapse,
  Stack
} from "@mui/material"
import React, {useState, useEffect, useCallback} from "react"
import {getFilters, getSubStringFilters, getRangeFilters, formatFromReportDateString, formatRemovalStats, formatRemovalStatsString, getSubscriptionStatusStyle, getInviteStatusStyle, getBillingStatusStyle } from '../../../../utils/helpers';
import { BooleanOptions, booleanStringType, CompanyType, CorpUserType, SortType, CorpSortByType, dateRangeFilter, UsersRangeFilterType, UsersRangeFilterOptions, subscribedSubscriptionStatusFilterOptions, subscriptionStatusStringType,
BrokerSourceOptions, BrokerSourceType, RemovalStatsType, InviteStatusStringType, InviteStatusOptions, BillingStatusStringType, BillingStatusOptions} from "../Types"
import scan from '@meprism/shared/src/assets/icons/scan.svg'
import user from '@meprism/shared/src/assets/icons/participating.svg'
import PieChartCard from '../../../shared/atom/PieChart';
import dayjs from 'dayjs'
import CustomDatePicker from '../../../shared/atom/inputs/DatePicker';
import { ArrowDownward, ArrowUpward, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import CustomTablePagination from "../../../shared/atom/TablePagination/TablePagination"
import { LookerCorpCodesApi, createPaginatedReportApi, PaginatedReportArgs, PaginatedReportReturn, createLookerAllCorporateStatsApi } from "../../../../redux/corporateCodeService"
import { useAppDispatch } from "../../../../redux/storeExports"
import {CircularProgress} from "@mui/material";
import { LookerReportsErrors } from '../../../shared/molecule/LookerReportsErrors';
import { capitalize } from 'lodash';

type CorpReportProps = {
  companyReportSyncTime : string  
  corpUsersReportSyncTime : string
};

export const CorpTab = ({companyReportSyncTime, corpUsersReportSyncTime}: CorpReportProps) =>{
    const dispatch = useAppDispatch()
    const [expandedMuid, setExpandedMuid] = useState('')
    const [corpUsers, setCorpUsers] = useState<CorpUserType[]>([])
    const [Company, setCompany] = useState< CompanyType | null>(null)
    const [loading, setIsLoading] = useState(false)
    const [companySearchValue, setCompanySearchValue] = useState('All')
    const [searchValue, setSearchValue] = useState('')
    const [blastEmailFilter, setBlastEmailFilter] = useState<booleanStringType | ''>('')
    const [brokerSourceFilter, setBrokerSourceFilter] = useState<BrokerSourceType|''>('')
    const [brokerSourceAllStatsFilter, setBrokerSourceAllStatsFilter] = useState<BrokerSourceType[]>([])
    const [scanFilter, setScanFilter] = useState<booleanStringType | ''>('')
    const [startDate, setStartDate] = useState<dayjs.Dayjs | undefined>(undefined)
    const [endDate, setEndDate] = useState<dayjs.Dayjs | undefined>(undefined)
    const [sortType, setSortType] = useState<SortType>('DESC') 
    const [brokerSourceKey, setBrokerSourceKey] = useState<BrokerSourceType | ''>('')
    const [sortBy, setSortBy] = useState('onboarding_date')
    const [companyNameOptions, setCompanyNameOptions] = useState<string[]>(['All'])
      const [rangeFilter, setRangeFilter] = useState<UsersRangeFilterType | null>(null)
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [hasNext, setHasNext] = useState(false)
    const [refetch, setRefetch] = useState(true)
    const [fetchNextPage, setFetchNextPage] = useState(false)
    const [newPage, setNewPage] = useState(0)
    const [offset, setOffset] = useState(0)
    const [companyRefetch, setCompanyRefetch] = useState(true)
    const colors = ['#C67EFF', '#426BF0', '#E2B93B', '#27AE60']; 
    const [sortStyle, setSortStyle] = useState({'email':'ASC', 'onboarding_date':'DESC', 'name':'ASC', 'code':'ASC','records_found':'ASC', 'records_removed':'ASC', 'records_removing':'ASC', 'expire_time': 'ASC'})
    const [dateRangeFilterErrors, setDateRangeFilterErrors] = useState(dateRangeFilter);
    const [allCompanyStats, setAllCompanyStats] = useState<Record<string, number | RemovalStatsType> | null>(null)
    const [getAllCorporateChartData,setGetAllCorporateChartData] = useState<Boolean | null>(null)
    const [subscriptionStatusFilter, setSubscriptionStatusFilter] = useState<subscriptionStatusStringType[]>([])
    const [inviteStatusFilter, setInviteStatusFilter] = useState<InviteStatusStringType[]>([])
    const [billingStatusFilter, setBillingStatusFilter] = useState<BillingStatusStringType[]>([])
    
    const ToggleSort = useCallback((sortByValue: CorpSortByType, sortType?: SortType, refetch: boolean = true) => {
            if(sortByValue!=='records_found' && sortByValue!=='records_removed' && sortByValue!=='records_removing'){
                setBrokerSourceFilter('')
            }
            const newSort = sortType? sortType : sortStyle[sortByValue] === 'ASC' ? 'DESC' : 'ASC'
            setSortStyle({ ...sortStyle, [sortByValue]: newSort })
            if(refetch){
                setSortType(newSort)
                setSortBy(sortByValue)
                setRefetch(true)
            }
        },[sortStyle])

    const getSortStyle = (sortByValue: CorpSortByType) => {
        const Icon = sortStyle[sortByValue] === 'DESC' ? ArrowDownward : ArrowUpward;
        const color = sortBy === sortByValue ? 'error' : 'primary';
        return <Icon color={color}/>;
    };

    const getCompany = useCallback(async () => {
        setPage(1)
        try {
            const company = await dispatch(createPaginatedReportApi({
                table: 'company_report',
                page_size: 1,
                sort_by: 'participating',
                Filters: {
                    filters: { code: companySearchValue },
                    search_filter: {},
                    date_range_filter: []
                },
                order: 'DESC',
                offset: 0
            })).unwrap()

            //@ts-ignore
            setCompany(company.data.length !== 0 ? company.data[0] : {})
        } catch (error) {
            console.error('Error fetching company:', error)
        }
    }, [dispatch, companySearchValue])

    const getAllCompanyStats = useCallback(async () => {
        setPage(1)
        const companyStats = await dispatch(createLookerAllCorporateStatsApi()).unwrap()
        setAllCompanyStats(companyStats)
    }, [dispatch])

    const getRemovalsDetails=(title: string, recordString: string)=>{
        let records = formatRemovalStatsString(recordString)
        const {total, ...formattedRecords} = records
        records = {...formattedRecords, total}
        return(
            <Paper
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                ...colStyle,
                minWidth: "350px",
                backgroundColor:"#f9f9f9",
            }}
            >
            <Typography variant="body2" fontWeight="bold" mx={10} sx={{whiteSpace:'wrap', wordBreak:'break-word'}}>
                {title}
            </Typography>
            <Table size="small" sx={{ mt: 1, backgroundColor:'#fff'}} >
                <TableBody>
                {Object.entries(records).map(([key, value]) => (
                    <TableRow key={key}>
                    <TableCell>{key}</TableCell>
                    <TableCell>{value}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
            </Paper>
        )
    }

    useEffect(()=>{
        const getCodes = async()=>{
            const codes : string[] = await dispatch(LookerCorpCodesApi()).unwrap()
            setCompanyNameOptions(['All',...codes])
        }
        getCodes()
    },[dispatch])

    useEffect(()=>{
            if(startDate && !endDate){
                setEndDate(dayjs())
            }
        }, [startDate, endDate])

    useEffect(()=>{
            const fetchCorpUsersReport= async()=>{
                setIsLoading(true)
                let newOffset = 0;
                try{
                    if(fetchNextPage){
                        if(newPage < page){
                            newOffset = Math.max(offset - pageSize, 0)
                            setPage(page -1)
                        }else{
                            newOffset = pageSize + offset
                            setPage(page +1)
                    }
                    }
                    const code = companySearchValue==='All'? '': companySearchValue
                    const formattedRangeFilter = rangeFilter ? rangeFilter === 'Expire Date' ? 'Expire Time' : rangeFilter : null
                    let sortByRemovals = false
                    if(brokerSourceFilter && (sortBy!=='records_found' && sortBy!=='records_removed' && sortBy!=='records_removing')){
                        setSortBy('records_found')
                        setSortType('DESC')
                        ToggleSort('records_found', 'DESC', false)
                        sortByRemovals = true
                    }
                     
                    if(brokerSourceFilter)setBrokerSourceKey(brokerSourceFilter)
                    else setBrokerSourceKey('')

                    const params : PaginatedReportArgs = {
                    "table" : "corp_users_report",
                    "page_size": pageSize,
                    "sort_by": sortByRemovals? 'records_found' : sortBy,
                    "offset" : fetchNextPage? newOffset : 0, 
                    "order" : sortByRemovals? 'DESC': sortType,
                    "Filters":{
                        "filters": getFilters({
                            "code": code, 
                            blast_emails_sent: blastEmailFilter? blastEmailFilter==='True': null, 
                            first_scan_complete: scanFilter? scanFilter==='True': null, 
                            subscription_status: subscriptionStatusFilter,
                            invite_status: inviteStatusFilter,
                            billing_status: billingStatusFilter
                        }),
                        "search_filter" : getSubStringFilters(searchValue),
                        "date_range_filter": getRangeFilters([{rangeFilter: formattedRangeFilter, startDate, endDate}]),
                        "broker_source_filter": brokerSourceFilter? brokerSourceFilter: 'total'
                    }
                    }
                    const response : PaginatedReportReturn = await dispatch(createPaginatedReportApi(params)).unwrap()
                    setCorpUsers(response.data)
                    setHasNext(response.has_next)
                }
                catch(e){
                    console.log('error getting looker corp users report: ', e)
                }finally{
                    setIsLoading(false)
                    if (fetchNextPage) {
                        setOffset(newOffset)
                    } else {
                        setOffset(0)
                    }
                    setFetchNextPage(false)
                }
            }
            if(refetch){
                if(companyRefetch){
                    if(companySearchValue==='All' || !companySearchValue){
                        setGetAllCorporateChartData(true)
                        getAllCompanyStats()
                    }
                    else{
                        setGetAllCorporateChartData(false)
                        getCompany()
                    }
                }
                if(!fetchNextPage){
                    setPage(1)
                }
                fetchCorpUsersReport()
            }
            setRefetch(false)
        },[refetch, searchValue, rangeFilter, startDate, endDate, dispatch, subscriptionStatusFilter, inviteStatusFilter, billingStatusFilter,
            blastEmailFilter, companySearchValue, scanFilter,
            pageSize, sortBy, sortType, offset, fetchNextPage, newPage, page, companyRefetch,
            getCompany, getAllCompanyStats, brokerSourceFilter, ToggleSort
        ])
    
        const getNextPage = (newPage: number)=>{
            setNewPage(newPage)
            setFetchNextPage(true)
            setRefetch(true)
        }
        
        const setNewPageSize = (newPageSize: number)=>{
            setPageSize(newPageSize)
            setRefetch(true)
        }

        const formatRemovalRecords = (record: string) =>{
            return brokerSourceKey ? 
            formatRemovalStatsString(record)[brokerSourceKey]: formatRemovalStatsString(record).total
        }


    const colStyle = {
        fontSize: '16px',
        whiteSpace: 'nowrap',
        minWidth: 'max-content',
        maxWidth: 'max-content'
    }

    const getRemovalChartData = () => {
        return [
            {
                value: Company? Number(formatRemovalStats(Company.removing, brokerSourceAllStatsFilter)):0,
                name: 'Removing',
                color: colors[2],
                icon: user
            },
            {
                value: Company? Number(formatRemovalStats(Company.removed, brokerSourceAllStatsFilter)):0,
                name: 'Removed',
                color: colors[3],
                icon: scan
            }
        ]
    }

    const getCorpUsersChartData = () => {
        const isExecutive = Company?.account_type === 'executive';
        return [
            {
                value: isExecutive 
                    ? Company? Number(Company.limit) : 0
                    : Number(Company?.invited ?? 0),
                name: isExecutive ? 'Limit' : 'Pending Invitations',
                color: colors[0],
                icon: user
            },
            {
                value:  Company? Number(Company.participating):0,
                name: 'Total Corporate Users',
                color: colors[1],
                icon: scan
            }
        ]
    }

    const getAllRemovalChartData = () => {
        return [
            {
                value: allCompanyStats? Number(formatRemovalStats(allCompanyStats.total_removing as RemovalStatsType, brokerSourceAllStatsFilter)):0,
                name: 'Total Removing',
                color: colors[2],
                icon: user
            },
            {
                value: allCompanyStats? Number(formatRemovalStats(allCompanyStats.total_removed as RemovalStatsType, brokerSourceAllStatsFilter)):0,
                name: 'Total Removed',
                color: colors[3],
                icon: scan
            }
        ]
    }

    const getAllCorpUsersChartData = () => {
        return [
            {
                value: allCompanyStats?.total_codes as number ?? 0,
                name: 'Total Corporate Codes',
                color: colors[0],
                icon: user
            },
            {
                value: allCompanyStats?.total_corporate_users as number ?? 0,
                name: 'Total Corporate Users',
                color: colors[1],
                icon: scan
            }
        ]
    }

    const onCorpUserSearch = () => {        
        const checkDateRangeError = Boolean(startDate || endDate || rangeFilter);
        if(checkDateRangeError){
            const newErrors = {
                dateFilter: !rangeFilter,
                startDate: !startDate,
                endDate: !endDate,
            };
            const hasError = Object.values(newErrors).some(value => value === true);
            setDateRangeFilterErrors(newErrors);
            if (hasError) return
        }
        setDateRangeFilterErrors(dateRangeFilter)
        setRefetch(true);
    };

    return(
        <Box width={'100%'}>
            <Typography variant='h3' fontSize={24} color={'#3A155A'} mb={5}>Company Stats</Typography>
            <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>                
                <Grid container spacing={4} mb={5}>
                   <Grid item lg={12} md={12} xs={12} mb={2} sx={{display:'flex'}}>
                        <Box
                            sx={{border:'1px green solid', backgroundColor:"white", py:3, px:2, borderRadius:2, color:"green"}}
                        >
                            <Typography variant='h4' sx={{color:'success.main'}}>Last Data Sync: {companyReportSyncTime}</Typography>
                        </Box>
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                            <Autocomplete
                                options={companyNameOptions}
                                value={companySearchValue}
                                onChange={(event, newValue) => {
                                    setCompanySearchValue(newValue);
                                }}
                                disableClearable
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Search Company"
                                />
                                )}
                                fullWidth
                                isOptionEqualToValue={(option, value) => option === value}
                            />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Button
                            variant="contained"
                            disabled={loading}
                            color="primary"
                            onClick={()=>{setCompanyRefetch(true) 
                                setRefetch(true)}}
                            sx={{width: '50%', height: '100%'}}                                                    
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Divider sx={{mt: 5, mb: 5}}/>
            <Autocomplete
                multiple
                options={BrokerSourceOptions}
                value={brokerSourceAllStatsFilter}
                onChange={(event, newValue) => {
                    setBrokerSourceAllStatsFilter(newValue);
                }}
                clearOnEscape
                renderInput={(params) => (
                <TextField
                    {...params}
                    label="Broker Source"
                />
                )}
                fullWidth
                limitTags={1}
                isOptionEqualToValue={(option, value) => option === value}
                renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip label={option} {...getTagProps({ index })} />
                ))
                }
                sx={{width: '25%', height: '10%'}}
            />
            <Grid container spacing={4} mt={1} mb={10} width={'100%'}>
                <Grid item lg={6} md={6} xs={12}>
                    <PieChartCard
                        title="Removal Stats"
                        chartData={getAllCorporateChartData? getAllRemovalChartData() : getRemovalChartData()}
                        bgcolor={'#C67EFF33'}
                    />
                </Grid>
                <Grid item lg={6} md={6} xs={12}>
                    <PieChartCard
                        title="Participant Stats"
                        chartData={getAllCorporateChartData? getAllCorpUsersChartData() : getCorpUsersChartData()}
                        bgcolor={'#C67EFF33'}
                    />
                </Grid>
            </Grid>
            <Divider sx={{mt: 5, mb: 5}}/>
            {loading?
             <Box
                sx={{
                    width: '100%',
                    height: '50vh',
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}>
                <CircularProgress sx={{ alignSelf: 'center', justifySelf: 'center' }} />
            </Box>:<>
            <Typography variant='h3' mt={5} fontSize={24} color={'#3A155A'} mb={5}>Company Users Stats</Typography>  
            <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Grid container spacing={4} mb={5}>
                    <Grid item lg={12} md={12} xs={12} mb={5} sx={{display:'flex'}}>
                        <Box
                            sx={{border:'1px green solid', backgroundColor:"white", py:3, px:2, borderRadius:2, color:"green"}}
                        >
                            <Typography variant='h4' sx={{color:'success.main'}}>Last Data Sync: {corpUsersReportSyncTime}</Typography>
                        </Box>
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <TextField
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            label="Search by Muid or Email"
                            size="small"
                            fullWidth
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            options={BooleanOptions}
                            value={scanFilter}
                            onChange={(event, newValue) => {
                                setScanFilter(newValue as booleanStringType);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="First Scan Complete"
                            />
                            )}
                            fullWidth
                            isOptionEqualToValue={(option, value) => option === value}
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            options={BooleanOptions}
                            value={blastEmailFilter as booleanStringType}
                            onChange={(event, newValue) => {
                                setBlastEmailFilter(newValue as booleanStringType);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Blast Email Sent"
                            />
                            )}
                            fullWidth
                            isOptionEqualToValue={(option, value) => option === value}
                        />
                    </Grid>
                     <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            multiple
                            options={subscribedSubscriptionStatusFilterOptions}
                            value={subscriptionStatusFilter}
                            onChange={(event, newValue) => {
                                setSubscriptionStatusFilter(newValue);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Subscription Status"
                            />
                            )}
                            fullWidth
                            limitTags={1}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip label={option} {...getTagProps({ index })} />
                            ))
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            multiple
                            options={InviteStatusOptions}
                            value={inviteStatusFilter}
                            onChange={(event, newValue) => {
                                setInviteStatusFilter(newValue);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Invite Status"
                            />
                            )}
                            fullWidth
                            limitTags={1}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip label={option} {...getTagProps({ index })} />
                            ))
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            multiple
                            options={BillingStatusOptions}
                            value={billingStatusFilter}
                            onChange={(event, newValue) => {
                                setBillingStatusFilter(newValue);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Billing Status"
                            />
                            )}
                            fullWidth
                            limitTags={1}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip label={option} {...getTagProps({ index })} />
                            ))
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            options={BrokerSourceOptions}
                            value={brokerSourceFilter}
                            onChange={(event, newValue) => {
                                setBrokerSourceFilter(newValue as BrokerSourceType);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Broker Source"
                            />
                            )}
                            fullWidth
                            limitTags={1}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip label={option} {...getTagProps({ index })} />
                            ))
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            options={UsersRangeFilterOptions}
                            value={rangeFilter}
                            onChange={(event, newValue) => {
                                setRangeFilter(newValue as UsersRangeFilterType);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Filter By Date"
                            />
                            )}
                            fullWidth
                            isOptionEqualToValue={(option, value) => option === value}
                        />
                        {
                            dateRangeFilterErrors['dateFilter'] && <LookerReportsErrors errorKey='date type' filter='date'/>
                        }
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <CustomDatePicker
                            label="Start Date"
                            value={startDate? startDate : null}
                            onChange={(value)=>{value? setStartDate(value): setStartDate(undefined)}}
                            disableFuture
                            clearable
                            maxDate={endDate}
                        />
                        {
                            dateRangeFilterErrors['startDate'] && <LookerReportsErrors errorKey='start date' filter='date'/>
                        }
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <CustomDatePicker
                            label="End Date"
                            value={endDate? endDate : null}
                            onChange={(value)=>{value? setEndDate(value): setEndDate(undefined)}}
                            disableFuture
                            clearable
                            minDate={startDate}
                        />
                        {
                            dateRangeFilterErrors['endDate'] && <LookerReportsErrors errorKey='end date' filter='date'/>
                        }
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={()=>onCorpUserSearch()}
                            sx={{width: '50%', height: '47px'}}                                                    
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <TableContainer component={Paper} style={{ marginTop: 20 }}>
                <Table sx={{minWidth: 1400, overflow: 'auto' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                            </TableCell>
                            <TableCell>MUID</TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Email
                                    <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('email')
                                                ToggleSort('email')
                                            }}
                                    >
                                        {getSortStyle('email')}
                                    </Button>
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Name
                                    <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('name')
                                                ToggleSort('name')
                                            }}
                                    >
                                            {getSortStyle('name')}
                                    </Button>
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Corporate Code
                                    <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('code')
                                                ToggleSort('code')
                                            }}
                                    >
                                            {getSortStyle('code')}
                                    </Button>
                                </Box>
                            </TableCell>
                            <TableCell>Records Found
                                <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('records_found')
                                                ToggleSort('records_found')
                                            }}
                                        >
                                        {getSortStyle('records_found')}
                                </Button>
                            </TableCell>
                            <TableCell>Records Removed
                                <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('records_removed')
                                                ToggleSort('records_removed')
                                            }}
                                        >
                                        {getSortStyle('records_removed')}
                                </Button>
                            </TableCell>
                            <TableCell>Records Removing
                                <Button onClick={(e: React.MouseEvent)=>
                                        {
                                            setSortBy('records_removing')
                                            ToggleSort('records_removing')
                                        }}
                                    >
                                    {getSortStyle('records_removing')}
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Invite Status
                                </Box>
                            </TableCell>
                             <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Onboarding Date 
                                    <Button onClick={(e: React.MouseEvent)=>
                                                {
                                                    setSortBy('onboarding_date')
                                                    ToggleSort('onboarding_date')
                                                }}
                                            >
                                            {getSortStyle('onboarding_date')}
                                    </Button>
                                </Box>
                            </TableCell>
                             <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Subscription Status
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Subscription Expires At 
                                    <Button onClick={(e: React.MouseEvent)=>
                                                {
                                                    setSortBy('expire_time')
                                                    ToggleSort('expire_time')
                                                }}
                                            >
                                            {getSortStyle('expire_time')}
                                    </Button>
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Billing Status
                                </Box>
                            </TableCell>
                            <TableCell>Blast Emails Sent</TableCell>
                            <TableCell>First Scan Complete</TableCell>
                            
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {   Array.isArray(corpUsers) &&
                            corpUsers.length===0 &&
                                <TableRow>
                                    <TableCell colSpan={14} sx={{textAlign:"center"}}>
                                        No Match Found
                                    </TableCell>
                                </TableRow>
                        }
                        {Array.isArray(corpUsers) && corpUsers.length!==0 && corpUsers
                            .map((user: CorpUserType, index: number) => (
                            <>
                            <TableRow
                                key={index}
                                sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
                            >
                                <TableCell>
                                    <Button onClick={()=>expandedMuid===user.muid?setExpandedMuid(''):setExpandedMuid(user.muid)}>
                                        {expandedMuid===user.muid?
                                        <KeyboardArrowUp/> :
                                        <KeyboardArrowDown/>}
                                    </Button>
                                </TableCell>
                                <TableCell sx={{...colStyle}}>{user.muid}</TableCell>
                                <TableCell sx={{...colStyle}}>{user.email? user.email : '-'}</TableCell>
                                <TableCell sx={{...colStyle}}>{user.name? user.name : '-'}</TableCell>
                                <TableCell sx={{...colStyle, minWidth:200}}>{user.code}</TableCell>
                                <TableCell sx={{...colStyle, minWidth:200}}>{formatRemovalRecords(user.records_found)}</TableCell>
                                <TableCell sx={{...colStyle, minWidth:220}}>{formatRemovalRecords(user.records_removed)}</TableCell>
                                <TableCell sx={{...colStyle, minWidth:220}}>{formatRemovalRecords(user.records_removing)}</TableCell>
                                <TableCell sx={{...colStyle, minWidth: 200, ...getInviteStatusStyle(user.invite_status)}}>{user.invite_status? user.invite_status : '-'}</TableCell>
                                <TableCell sx={{...colStyle, minWidth:200}}>{user.onboarding_date? formatFromReportDateString(user.onboarding_date):'-'}</TableCell>
                                <TableCell sx={{...colStyle, minWidth: 200, ...getSubscriptionStatusStyle(user.subscription_status)}}>{user.subscription_status? user.subscription_status:'-'}</TableCell>
                                <TableCell sx={{...colStyle, minWidth:280}}>{user.expire_time? formatFromReportDateString(user.expire_time):'-'}</TableCell>
                                <TableCell sx={{...colStyle, minWidth: 200, ...getBillingStatusStyle(user.billing_status)}}>{user.billing_status? user.billing_status : '-'}</TableCell>
                                <TableCell sx={{...colStyle, minWidth:150}}>{user.blast_emails_sent? capitalize(user.blast_emails_sent):'-'}</TableCell>
                                <TableCell sx={{...colStyle, minWidth:170}}>{user.first_scan_complete? capitalize(user.first_scan_complete):'-'}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={14} sx={{ paddingBottom: 0, paddingTop: 0 }}>
                                    <Collapse
                                    in={expandedMuid === user.muid}
                                    timeout="auto"
                                    unmountOnExit
                                    >
                                        <Stack spacing={4} px={2} py={4} direction={'row'} sx={{
                                            minHeight: '120px',
                                            height: 'auto',
                                            maxHeight: 'max-content'  
                                        }}>
                                                <Typography variant="h3" alignSelf={'center'} maxWidth={150} minWidth={150}>
                                                    Removals Details
                                                </Typography>
                                                {getRemovalsDetails('Records Found', user.records_found)}
                                                {getRemovalsDetails('Records Removed', user.records_removed)}
                                                {getRemovalsDetails('Records Removing', user.records_removing)}
                                                
                                        </Stack>
                                    </Collapse>
                                </TableCell>
                            </TableRow>
                            </>                                
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <CustomTablePagination
                onPageChange={(newPage: number) => getNextPage(newPage)}
                onPageSizeChange={(pageSize: number) =>
                    setNewPageSize(pageSize)
                }
                page={page}
                pageSize={pageSize}
                hasNext={hasNext}
            />        
        </>}
        </Box>
    )
}